export default __webpack_public_path__ + "static/media/wi-sprinkle.7b48d7df.svg";